export default "__VITE_ASSET__44b07139__"